import { HttpErrorResponse } from '@angular/common/http';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { ENT_PAGE_TITLE } from 'projects/enterprise/src/app/core/constants/EnterpriseConstants';
import * as _ from 'underscore';

export class EnterpriseImplementation {
   public router: any;
   public http: any;
   public route: any;
   public universalService: any;
   public globalService: any;
   loggerService: any;
   public tableRecords:any = [];
   public columnMaps:any = [];
   public moreOptions:any = [];
   public pageNumber: number = 1;
   public itemsPerPage: number = 50; //default number should be 50;
   public reportItemsPerPage: number = 50;
   public externalSharingItemsPerPage:any = 10;
   public tfListItemsPerPage:number = 20;
   public totalTfCount:number = 0;
   public tableCaption:any;
   public isAllUserResult:boolean = false;
   public isSearchUserResult:boolean = false;
   public activityEvents:any = [];
   public activityLogsData:any = [];
   static singleInstance = null;
   public isMoreOptionsRequired:boolean = false;
   public activityReportPayload:any = [];
   private units : Array<string> = ['B','KB','MB', 'GB', 'TB'];
   public showAddUserModal:boolean = false;
   public showUploadCsvModal:boolean =false;
   containerHeightCalc: any;
   
   public totalUsers:any = 0;
   public previousOffset:any = 0;
   public nextOffset:any = 0;
   public previousLink:any = undefined;
   public nextLink:any = undefined;
   public totalPages:any = 0;
   entNotifsPreviousLink: any;
   entNotifsNextLink: any;
   public uploadedCSVName:any;
   public allEntNotifications: any = [];
   public totalItems:any = 0;

   public payload:any;
   reportTodate: string;
   reportFromdate: string;
   timezone: string = "Asia/Calcutta";
   showListData : boolean = false;
   showAddGroupPanel : boolean = false;
   showEditGroupPanel : boolean = false;
   usersMap : Map<String,String> = new Map();
   displayList:any = [];
   groupName : String = "";
   existingGroupName : String = "";
   groupNameChanged: boolean = false;
   groupKey: String = "";
   serverMembersList: any = [];
   validGroupName: boolean = false;
   updateMemberList: boolean = false;
   groupDesc : String = "";
   existingGroupDesc : String = "";
   groupDescChanged: boolean = false;
   groupCount = 0;
   isSearchGroupResult: boolean = false;

   name : String = "";
   existingName : String = "";
   nameChanged: boolean = false;
   validName: boolean = false;
   desc : String = "";
   existingDesc : String = "";
   descChanged: boolean = false;
   localStorageService:any;
   cleverTapEventsService:any;

   pendingCountCurrentPage:number;

   constructor(globalService) {
      this.globalService = globalService;
      this.http = globalService.getHttpClientRef();
      this.showUploadCsvModal = false;
      this.universalService = globalService.getUniversalServiceRef();
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
      this.router = globalService.getRouterRef();
      this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
      
   }

   public static getInstance(globalService): EnterpriseImplementation {
      if (this.singleInstance == null) {
         this.singleInstance = new EnterpriseImplementation(globalService);
         return this.singleInstance;
      } else {
         return this.singleInstance;
      }
   }

   public setHandler(globalService) {
      
      this.route = globalService.getActivatedRoute();
      this.localStorageService = globalService.getLocalStorageSvcRef();
      
   }

   formatTimeStamp(timestamp) {
      var dateToFormat = new Date(timestamp);
      return (dateToFormat.getDate() + " " + this.universalService.SHORT_MONTH_NAMES[dateToFormat.getMonth()] + " " + dateToFormat.getFullYear());
   }

   convertNgbDateToTimeStamp(date) {
      if(!date.year || !date.month || !date.day){
         var d = new Date(date);
         date = {
            year : d.getFullYear(),
            month : d.getMonth(),
            day : d.getDate()
         } 
      }else{
         date = {
            year : date.year,
            month : date.month - 1,
            day : date.day
         } 
      }
      return  new Date(date.year, date.month, date.day, 0, 0, 0, 0).getTime();
   }

   updateListData(newResponse, itemsPerPage) {
      if(this.pageNumber == 1) {
         if(this.tableRecords.length == itemsPerPage) {
            this.tableRecords.splice(this.tableRecords.length - 1, 1)
         }

         newResponse['name'] = this.universalService.firstName + " " + this.universalService.lastName;
         newResponse['tfCreatedBy'] = { 
            firstName : this.universalService.firstName, 
            lastName : this.universalService.lastName,
            userId : USER_DETAILS["USER_DETAILS"]["userId"]
         }
         newResponse['tfLastUpdatedBy'] = newResponse['tfCreatedBy'];
         newResponse['statusName'] = 'Active';
         this.tableRecords.unshift(newResponse);
      }
   }

   updateTeamFolderCount() {
      var self = this;
      self.totalTfCount = self.totalTfCount + 1;
      self.universalService.entHeaderTitle = ENT_PAGE_TITLE.TEAM_FOLDERS + " ("+ self.totalTfCount +")";
   }

   /**
    * To get all user data for usage graph
    * @param url 
    */
   public async getListData(url) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            resp => {
               self.showListData = true;
               resolve(resp);
            },
            err => {
               reject(err);
            }
         )
      })
   }

   /**
    * Create team folder api
    * @param url 
    */
    public async createTeamFolder(url, payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.post(url, payload).subscribe(
            resp => {
               self.updateTeamFolderCount();
               self.updateListData(resp, self.tfListItemsPerPage);
               self.universalService.showLoader = false;
               // let sizeInBytes = parseFloat((resp.sizeInBytes / (1024 * 1024 * 1024)).toFixed(2));
               let sizeInBytes = self.getSize(resp);
               resp['orgSizeInBytes'] = resp.sizeInBytes;
               resp['sizeInBytes'] = sizeInBytes;
               resolve(resp);
            },
            async error=>{
               self.universalService.showErrorMessage(error);
               self.universalService.isServerError = false;
               reject(error);
           },
         )
      })
   }


   /**
    * Duplicate team folder api
    * @param url 
    */
    public async tfDuplicate(url,payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.post(url,payload).subscribe(
            resp => {
               self.updateTeamFolderCount();
               self.updateListData(resp, self.tfListItemsPerPage);
               self.universalService.showLoader = false;
               let msg = "Team Folder " + '"' + resp.tfName + '"' + " created successfully";
               self.universalService.showToast(msg,"success");
               var userData = self.localStorageService.getUserData(true);
               // let sizeInBytes = parseFloat((resp.sizeInBytes / (1024 * 1024 * 1024)).toFixed(2));
               let sizeInBytes = self.getSize(resp);
               resp['orgSizeInBytes'] = resp.sizeInBytes;
               resp['sizeInBytes'] = sizeInBytes;
               resp["tfCreatedBy"] = {
                  "userId" : userData["userId"],
                  "firstName" : userData["firstName"] ? userData["firstName"] : "-",
                  "lastName" : userData["lastName"] ? userData["lastName"] : "-"
                }
               resp["tfLastUpdatedBy"] = {
               "userId" : userData["userId"],
               "firstName" : userData["firstName"] ? userData["firstName"] : "-",
               "lastName" : userData["lastName"] ? userData["lastName"] : "-"
               }
               resolve(resp);
            },
            async err => {
               self.universalService.showErrorMessage(err);
               self.universalService.isServerError = false;
               reject(err);
            }
         )
      })
   }

   /**
    * Delete team folder api
    * @param url 
    */
   public async tfDelete(url,payload,tfName) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            resp => {
               self.tableRecords.map(function(currentValue,index) {
                  if(payload.objectKey == currentValue.objectKey){
                     self.tableRecords[index]['statusName'] = "Deleted";
                     self.tableRecords[index]['status'] = "T";

                     var updatedRecord = self.tableRecords[index];
                     self.tableRecords.splice(index, 1);
                     self.tableRecords.unshift(updatedRecord);
                     self.universalService.showLoader = false;
                     let msg = "Team Folder " + '"' + tfName + '"' + " deleted successfully";
                     self.universalService.showToast(msg,"success");
                     resolve(resp);
                  }
               });

            },
            async err => {
               self.universalService.showErrorMessage(err);
               self.universalService.isServerError = false;
               reject(err);
            }
         )
      })
   }

   /**
    * Restore team folder api
    * @param url 
    */
    public async tfRestore(url,payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            resp => {
               self.tableRecords.map(function(currentValue,index) {
                  if(payload.objectKey == currentValue.objectKey){
                     currentValue = resp;
                     if (currentValue.tfCreatedBy) {
                        currentValue.name = currentValue.tfCreatedBy.firstName + " " + currentValue.tfCreatedBy.lastName;
                     }
                     // let sizeInBytes = parseFloat((resp.sizeInBytes / (1024 * 1024 * 1024)).toFixed(2));
                     let sizeInBytes = self.getSize(resp);
                     currentValue['orgSizeInBytes'] = resp.sizeInBytes;
                     currentValue['sizeInBytes'] = sizeInBytes;

                     self.tableRecords[index] = currentValue;

                     var updatedRecord = self.tableRecords[index];
                     self.tableRecords.splice(index, 1);
                     self.tableRecords.unshift(updatedRecord);
                     let msg = "Team Folder " + '"' + resp.tfName + '"' + " restored successfully";
                     self.universalService.showToast(msg,"success");
                     self.universalService.showLoader = false;
                     resolve(resp);
                  }
               });
            },
            async err => {
               self.universalService.showErrorMessage(err);
               self.universalService.isServerError = false;
               reject(err);
            }
         )
      })
   }

   public setUserListData(result,calledFromshowAllUsers = false,pageNo=1) {
      var self = this;
      this.isMoreOptionsRequired = true;
      if(result.objects != undefined && result.objects.length > 0) {
         this.totalUsers = result.totalRecords;

         result.objects.map(function(currentValue, index, arr) {
            currentValue.name= ((currentValue.firstName != undefined) ? currentValue.firstName : '') + " " + ((currentValue.lastName != undefined) ? currentValue.lastName : '');
            currentValue.storage= self.transformBytes(currentValue.usedSpace, 1, true) + "/" + self.transformBytes(currentValue.allocatedSpace, 1, true);
            let allotedStorageInGB = parseFloat((currentValue.allocatedSpace /(1024*1024*1024)).toFixed(1));
            if(calledFromshowAllUsers && self.usersMap[currentValue.userId] == undefined){
               self.usersMap[currentValue.userId] = currentValue;
            }
            currentValue['allotedStorageInGB'] = allotedStorageInGB
            if (currentValue.status == "P") {
               currentValue.createdDate = undefined;
               currentValue.lastLoginDate = undefined;
            }
         });
         this.tableRecords = result.objects;
         this.itemsPerPage = 50;
         this.pageNumber = pageNo;
         this.pendingCountCurrentPage = result["objects"].length;
         this.updateCountsAndTitle(result.totalRecords)
         this.getTotalPages(result.totalRecords,this.itemsPerPage);
       
      } else {
         this.tableRecords = [];
         this.totalPages = 0;
         this.pendingCountCurrentPage = 0;
      }
    }

    public setGroupsListData(result,modifyExistingList = "",pageNo){
      var self = this;
      if(modifyExistingList == "add" && this.isSearchGroupResult){
         return;
      }
      if(modifyExistingList == "add"){
         result["createdByName"] = (result.createdByFName ? result.createdByFName : "-") + " " + (result.createdByLName ? result.createdByLName : "");
         result["memberCount"] = 1;
         let idx = (this.pageNumber-1) * this.itemsPerPage ; 
         self.tableRecords.splice(idx, 0, result);
         self.getTotalPages(self.tableRecords.length,this.itemsPerPage);
      }
      else if(modifyExistingList == "remove"){
         if(self.isSearchGroupResult){
            let el = document.getElementById('showAllGroupsBtn');
            if(el){
               el.click()
            }
         }
         else{
            self.tableRecords = self.tableRecords.filter( obj => obj["groupKey"] != result["groupKey"]);
            self.getTotalPages(self.tableRecords.length,this.itemsPerPage);
            this.pageNumber = Math.min(this.pageNumber,this.totalPages);
         }
      }
      else if(modifyExistingList == "searchResult"){
         result["createdByName"] = (result.createdByFName ? result.createdByFName : "-") + " " + (result.createdByLName ? result.createdByLName : "");
         result["groupDesc"] = result["groupDesc"] ? result["groupDesc"] : "";
         this.tableRecords = [result];
      }
      else if(modifyExistingList == "rename"){
         self.tableRecords = self.tableRecords.map( function(obj){
            if(obj["groupKey"] == result["groupKey"]){
               if(result["groupName"]){
                  obj["groupName"] = result["groupName"];
               }
               if(result["groupDesc"]){
                  obj["groupDesc"] = result["groupDesc"];
               }
            }
            return obj;
         });
      }
      else if(modifyExistingList == "addMember"){
         self.tableRecords = self.tableRecords.map( function(obj){
            if(obj["groupKey"] == result["groupKey"]){
               obj["memberCount"] += result["membersAdded"];
            }
            return obj;
         });
      }
      else if(modifyExistingList == "deleteMember"){
         self.tableRecords = self.tableRecords.map( function(obj){
            if(obj["groupKey"] == result["groupKey"]){
               obj["memberCount"] -= result["membersAdded"];
            }
            return obj;
         });
      }
      else if(result["groups"]!=undefined){
         this.isMoreOptionsRequired = true;
         // this.tableRecords = result["groups"].map(ele => {
         //    let temp = self.usersMap[ele.createdBy]
         //    ele["createdByName"] = temp.firstName + " " + temp.lastName;
         // })
         this.tableRecords = result["groups"].map(function(ele){
            ele["createdByName"] = (ele.createdByFName ? ele.createdByFName : "-") + " " + (ele.createdByLName ? ele.createdByLName : "");
                  return ({
                    "createdDate": ele["createdDate"], 
                    "groupName": ele["groupName"],
                    "groupDesc": ele["groupDesc"] ? ele["groupDesc"] : "", 
                    "createdByName": ele["createdByName"],
                    "memberCount": ele["memberCount"] ? ele["memberCount"] : 1,
                    "groupKey" : ele["groupKey"],
                    "teamKey" :  ele["teamKey"] ? ele["teamKey"] : "",
                    "teamName" :  ele["teamName"] ? ele["teamName"] : ""
                   });
         });
         this.pendingCountCurrentPage = result["groups"].length;
         this.itemsPerPage = 50;
         this.pageNumber = pageNo;
         this.groupCount = result.totalRecords;
         this.getTotalPages(result.totalRecords,this.itemsPerPage);
      }else{
         this.tableRecords = [];
      }
      
   }

   /**
    * To get usage data for usage graph
    * @param url 
    */
   getDataUsageGraph(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
              
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting usage", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   /**
    * To convert bytes information to respective units format
    * @param value 
    * @param decimal 
    * @param valueInUnits 
    */
   transformBytes(value: any, decimal?:number, isUnitsRequired?:boolean, isGraph?: boolean): any {
       if(this.router.url == ('/')){ // to prevent this pipe to load when left menu is being loaded on about page when user is logged in
         return
       }
       let unit = 0;
       let precision:number;
       if(isGraph){
         value = value/(1024*1024*1024);
         unit=3;
       }else{
         while ( value >= 1024 && unit < 3) {
            value /= 1024;
            unit ++;
          }
       }
       
       precision= unit == 0 ? 0 : decimal!= null && decimal!= undefined? decimal: 2;
       if(value != null && value != "") {
         value = value ==0 ? value.toFixed(precision) : value.toFixed(precision); 
         if(value % 1 == 0) {
           value =  Math.trunc(value);
         }
       }
       return (isUnitsRequired) ? value  + ' ' + this.units[unit] : value;
   }

   searchValidation(searchKey) {
      if (searchKey == undefined || searchKey.length < 3) {
        return false;
      }
      return true;
    }
   
   getSearchedUserData(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               if(url.includes(ENV_CONFIG["commonUrls"]["entTeamFolderSearchUser"])){
                  var obj = {};
                  obj["users"] = suc.users.filter(person => person["status"] != "P");
                  obj["groups"] = suc["groups"];
                  resolve(obj);
               }else{
                  let activeUsers = suc.objects.filter(person => person["status"] != "P");
                  resolve(activeUsers);
               }
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting searched user details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   getSearchedGroupData(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               resolve(suc.groups);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting searched group details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   getSearchedUserDataByEmail(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               self.showListData = true;
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting searched user details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   getActivityEventsMaster(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting activity events details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   getActivityLogs(url, payload) {
      this.payload = payload
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.put(url, payload).subscribe(
            suc=>{
               self.showListData = true;
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting activity logs details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }
   
   public setActivityReportData(result, pageno) {
      var self = this;
      this.isMoreOptionsRequired = true;
      this.tableCaption = '';
      
      if(result!=null && result.objects != undefined && result.objects.length > 0) {
         this.previousOffset = result.previousOffset;
         this.nextOffset = result.nextOffset;
         result.objects.map(function(currentValue, index, arr) {
            currentValue.name= ((currentValue.actorFirstName != undefined) ? currentValue.actorFirstName : '') + " " + ((currentValue.actorLastName != undefined) ? currentValue.actorLastName : '');
            currentValue.fileExtn = "" ;
            if(currentValue.objectName!=undefined && currentValue.objectType!=undefined && currentValue.objectType == "FE"){
               currentValue.fileExtn = "." + [currentValue.objectName.substr(0,currentValue.objectName.lastIndexOf('.')),currentValue.objectName.substr(currentValue.objectName.lastIndexOf('.')+1,currentValue.objectName.length)][1];
               currentValue.objectName = [currentValue.objectName.substr(0,currentValue.objectName.lastIndexOf('.')),currentValue.objectName.substr(currentValue.objectName.lastIndexOf('.')+1,currentValue.objectName.length)][0]
            }
         });
         this.tableRecords = result.objects;
         this.moreOptions = [];
         this.itemsPerPage = this.reportItemsPerPage;
         this.pageNumber = pageno;
         if(this.pageNumber == 1){
            this.getTotalPages(result.totalRecords,this.itemsPerPage);
         }
         this.moreOptions = this.universalService.entMoreOption['reportOptions'];
      } else {
         this.tableRecords = [];
         this.totalPages = 0;
      }
    }
  

    getPendingData(url){
      var self = this;
      this.tableRecords = [];
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting pending invites.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   setTeamFoldersListData(result, pageno){
      var self = this;
      if (result.objects != undefined && result.objects.length > 0) {
         this.isMoreOptionsRequired = true;
         this.previousLink = result.previousLink;
         this.nextLink = result.nextLink;
         result.objects.map(function (currentValue, index, arr) {
            if (currentValue.tfCreatedBy) {
               currentValue.name = currentValue.tfCreatedBy.firstName + " " + currentValue.tfCreatedBy.lastName;
            }
            // let sizeInBytes = parseFloat((currentValue.sizeInBytes / (1024 * 1024 * 1024)).toFixed(2));
            let sizeInBytes = self.getSize(currentValue);
            currentValue['orgSizeInBytes'] = currentValue.sizeInBytes;
            currentValue['sizeInBytes'] = sizeInBytes;
         });
         this.tableRecords = result.objects;
         this.itemsPerPage = this.tfListItemsPerPage;
         this.pageNumber = pageno;
         if (this.pageNumber == 1) {
            this.getTotalPages(result.totalTfCount, this.tfListItemsPerPage);
         }
         self.universalService.showLoader = false;
        // this.universalService.baseFolderTfKey = result.baseFolderTfKey;
      } else {
         this.tableRecords = [];
         this.totalPages = 0;
         self.universalService.showLoader = false;
      }
   }

   setInviteListData(result,pageno=1){
      var self = this;
      if(result.objects != undefined && result.objects.length > 0) {
         this.isMoreOptionsRequired = true;
        // this.totalUsers = result.totalRecords;
         result.objects.map(function(currentValue, index, arr) {
            currentValue.name=currentValue.firstName + " " + currentValue.lastName;
            currentValue.storage= self.transformBytes(currentValue.usedSpace, 1, true) + "/" + self.transformBytes(currentValue.allocatedSpace, 1, true);
            let allotedStorageInGB = parseFloat((currentValue.allocatedSpace /(1024*1024*1024)).toFixed(1));
            currentValue['allotedStorageInGB'] = allotedStorageInGB
         });
        this.tableRecords = result.objects;
        this.itemsPerPage = 50;
        this.pageNumber = pageno;
        this.pendingCountCurrentPage = result["objects"].length;
        this.updateCountsAndTitle(result.totalRecords)
        this.getTotalPages(result.totalRecords,this.itemsPerPage);
        self.universalService.showLoader = false;

      } else {
         this.tableRecords = [];
         this.totalPages = 0;
      }
   }

   addEntUser(url, payload){
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.post(url, payload).subscribe(
            suc=>{
               resolve(suc);
            },
            error=>{
               if(error.status ! =403){
               // self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  console.log("error in getting add user.", error);
                  reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
               }
           },
         )
      })
   }


   deleteUser(url,user){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.delete(url).subscribe(
            suc=>{
               self.cleverTapEventsService.entDeleteUsr();
               self.universalService.showToast(TOAST["USER_DELETED"],"success");
               resolve(true);
            },
            error=>{
             console.log("error in getting pending invites.", error);
             self.universalService.showErrorMessage(error);
             self.universalService.isServerError = false;
             reject(error);
           },
         )
      });
   }


   disableUser(url,payload,user){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{
               self.cleverTapEventsService.entDisableUsr();
               self.tableRecords.map(function(currentValue,index) {
                  if(user.accountId == currentValue.accountId){
                     self.tableRecords[index]['statusName'] = "Disabled";
                     self.tableRecords[index]['status'] = "B";
                     self.universalService.showToast(TOAST["USER_DISABLED"],"success");

                     return;
                  }
               });
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting pending invites.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   setInactiveUsersListData(result,pageNo = 1){
      var self = this;
      self.universalService.showLoader = true;
      if(result.objects != undefined && result.objects.length > 0) {
         this.isMoreOptionsRequired = true;
        // this.totalUsers = result.totalRecords;
         result.objects.map(function(currentValue, index, arr) {
            currentValue.name=currentValue.firstName + " " + currentValue.lastName;
            currentValue.storage= self.transformBytes(currentValue.usedSpace, 1, true) + "/" + self.transformBytes(currentValue.allocatedSpace, 1, true);
            let allotedStorageInGB = parseFloat((currentValue.allocatedSpace /(1024*1024*1024)).toFixed(1));
            currentValue['allotedStorageInGB'] = allotedStorageInGB
         });
         
        this.tableRecords = result.objects;
        this.pageNumber = 1;
        self.universalService.showLoader = false;
        this.updateCountsAndTitle(result.totalRecords)
        this.tableRecords = result.objects;
        this.itemsPerPage = 50;
        this.pageNumber = pageNo;
        this.pendingCountCurrentPage = result["objects"].length;
        this.getTotalPages(result.totalRecords,this.itemsPerPage);
         self.universalService.showLoader = false;

      } else {
         this.tableRecords = [];
         this.totalPages = 0;
      }
   }

   enableUser(url,payload,user){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{
               self.tableRecords.map(function(currentValue,index) {
                  if(user.accountId == currentValue.accountId){
                     self.tableRecords[index]['statusName'] = "Active";
                     self.tableRecords[index]['status'] = "A";
                     self.universalService.showToast(TOAST["USER_ENABLED"],"success");

                     return;
                  }
               });
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting enableUser", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }
  
   updateUserDetails(url,payload){
      var self = this;
      var responseMess = "SUCCESS";
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{
              self.tableRecords.map(async function(currentValue,index) {
                  if(suc.accountId == currentValue.accountId){
                     let storage= self.transformBytes(self.tableRecords[index]['usedSpace'], 1, true) + "/" + self.transformBytes( (suc.storageQuota*1024*1024*1024) , 1, true);
                      if(self.tableRecords[index]['name']!=(suc.firstName + " " + suc.lastName)){
                         responseMess = "SUCCESS_GETLATEST";
                         self.tableRecords[index]['name'] = suc.firstName + " " + suc.lastName;

                      }
                     self.tableRecords[index]['allotedStorageInGB'] = suc.storageQuota;
                     self.tableRecords[index]['storage']=storage;
                     self.tableRecords[index]['firstName'] = suc.firstName;
                     self.tableRecords[index]['lastName'] = suc.lastName;
                     if(suc.admin!=undefined && suc.admin!=null)
                        self.tableRecords[index]['admin'] = suc.admin;
                     if(suc.mobileNumber!=undefined && suc.mobileNumber!=null)
                        self.tableRecords[index]['mobileNumber'] = suc.mobileNumber;
                     else
                        self.tableRecords[index]['mobileNumber'] = '';
                     if (responseMess == 'SUCCESS_GETLATEST' && self.router.url == '/manageusers' ){
                        let sortedArray = _.sortBy(self.tableRecords, (i)=>i.name.toLowerCase()); 
                        self.tableRecords =  sortedArray;

                     }
                     return;
                  }
               });
               resolve(responseMess);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in updateUserDetails.", error);
                  // self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
               }
           },
         )
      });
   }

   getActivityReport(url,payload,type){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload ,{responseType: 'blob'}).subscribe(
            async suc=>{
               if(suc.size > 0){
                  await self.setReportName(payload.toDate,payload.fromDate);
                  var downloadURL = window.URL.createObjectURL(suc);
                  var link = document.createElement('a');
                  link.href = downloadURL;
                  type == 'pdf' ? link.download = 'User_Activity_Report_' + self.reportTodate + '_' + self.reportFromdate  + ".pdf" : link.download = 'User_Activity_Report_' + self.reportTodate + '_' + self.reportFromdate + ".csv"
                  link.click();
               }else{
                  self.universalService.showToast(TOAST["EXPORT_REQUEST_SUCCESS"],'success')
               }
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getActivityReport.", error);
                  self.universalService.showToast(error["error"]["error"],'error')
                  self.universalService.isServerError = false;
                  reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
               }
           },
         )
      });
   }

   setReportName(toDate,fromDate){
      let toDateRedable = new Date(toDate);
      let fromDateRedable = new Date(fromDate); 
      this.reportTodate= [toDateRedable.getFullYear(), toDateRedable.getMonth() + 1, toDateRedable.getDate()].join('');
      this.reportFromdate = [fromDateRedable.getFullYear(), fromDateRedable.getMonth() + 1, fromDateRedable.getDate()].join('');
      return
   }
   
   setEntContHeight(className){
      var self = this;
      setTimeout(()=>{
         if(self.universalService.isMobileDevice){
            self.containerHeightCalc.calculateHeight(className,['.pseudo-mobile-header'],50)
         }else{
            self.containerHeightCalc.calculateHeight(className,['.pseudo-ent-header','.pseudo-header','.pseudo-top-header','.pseudo-tab'],79)
         }
         
      },800)
   }

   updateEntSettingsShare(url, payload){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{
               resolve({status:'success',"entData":suc});
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in updateEntSettingsShare.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject({status:'failed',errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
               }
           },
         )
      });
   }

   updateEntSettingsTFQuota(url, payload){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{
               resolve({status:'success',"entData":suc});
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in updateEntSettingsTFQuota.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject({status:'failed',errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
               }
           },
         )
      });
   }

   getEntNotifications(url){
     if(!this.universalService.isMobileDevice){
         this.toggleSmallLoader(true);
     }
     else{
         this.universalService.showLoader = true;
     }
     var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               if (suc["nextLink"]) 
                  self.entNotifsNextLink = suc["nextLink"]
               self.parseEntNotifications(suc);
               self.universalService.showLoader = false;
               if (!self.universalService.isMobileDevice) 
                  self.toggleSmallLoader(false);
               resolve(suc); 
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getEntNotifications.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  self.universalService.showLoader = false;
                  if(!this.universalService.isMobileDevice) self.toggleSmallLoader(false);
                  reject(error);
               }
           },
         )
      });
   }

   toggleSmallLoader(state){
      if(state) {
        jQuery(".spinner_loader").show();
      } else {
        jQuery(".spinner_loader").hide();
      }
    }

   async createUrlForNextLink(allNotifBottom,notifsHolderBottom, url) {
      if (notifsHolderBottom >= (0.95 * allNotifBottom) && this.entNotifsPreviousLink != this.entNotifsNextLink){
         this.entNotifsPreviousLink = this.entNotifsNextLink;
         this.getEntNotifications(url)
      }
      // if (notifsHolderBottom >= (0.95 * allNotifBottom) &&
      //     this.entNotifsNextLink!= ""  && this.entNotifsPreviousLink != this.entNotifsNextLink){       
      //     this.universalService.showLoader = true;
      //     this.universalService.loader = true;
      //     this.entNotifsPreviousLink = this.entNotifsNextLink;
      //     this.getNextPageData(url)
      //    alert("api call")
      // }
   }
     uploadCSV(url,file){
      var self = this;
      self.universalService.showLoader = false;
      const formData = new FormData();
      const httpOptions = { observe: 'events', reportProgress: true }
      formData.append("file", file);
      return new Promise(function (resolve, reject) {
         self.http.post(url, formData,httpOptions).subscribe(
            suc=>{
               // if(suc.status == '200'){
               //    AppEvents.startENTUpload.next({csvUploadedSucceessfully: true});
               //    let data = suc.text
               //    self.downloadCSV(data);
               // }
               resolve(suc);
            },
            error=>{
               console.log("upload error" ,error);
               if(error.status == '200'){
                  AppEvents.startENTUpload.next({csvUploadedSucceessfully: true});
                  let data = error.error.text
                  self.downloadCSV(data);
               }else{
                  if(error.status != 403 && error.status != 400){
                     self.universalService.showToast(error["error"]["error"],'error');
                     AppEvents.startENTUpload.next({csvUploadedSucceessfully: false});
                     self.universalService.isServerError = false;
                     reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
                  }else if(error.error.code == "TEJRF0400"){
                     self.universalService.showToast(TOAST["INVALID_CSV_UPLOAD"],'error');
                     AppEvents.startENTUpload.next({csvUploadedSucceessfully: false});
                     self.universalService.isServerError = false;
                     reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
                  }
               }
           },
         )
      })
   }

   downloadCSV(data){
      const blob = new Blob([data]);
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = this.uploadedCSVName
      link.click();
   }

   downloadSampleCSV(){
      var self = this;
      let url = 'https://static.jiocloud.com/web2.0/enterprise/sample.csv'
      fetch(url).then(res => res.blob()).then(file => {
         var downloadURL = window.URL.createObjectURL(file);
         var link = document.createElement('a');
         link.href = downloadURL;
         link.download = 'sample.csv'
         link.click();
      }).catch(() => {
         console.log("error in sample csv download.");
         self.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
         self.universalService.isServerError = false;
      })
      ;
   }

   deletePublicLink(url) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url).subscribe(
            suc => {
               resolve("SUCCESS");
            },
            error => {
               console.log("error in deletePublicLink.", error);
               if(error.status ! =403){
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject({ errorMsg: error["error"]["error"], errorCode: error["error"]["code"] });
               }
              
            },
         )
      });
   }

   deleteAllLink(url,payload){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            suc=>{

               resolve("SUCCESS");
            },
            error=>{
             console.log("error in deleteAllLink.", error);
             if(error.status ! =403){
               self.universalService.showErrorMessage(error);
               self.universalService.isServerError = false;
               reject({errorMsg:error["error"]["error"],errorCode:error["error"]["code"]});
             }
           },
         )
      });
   }
  public parseEntNotifications(data){
      var temp = data?.notifications;
      if(temp != undefined ) {
         temp.forEach(el => {
            var obj = JSON.parse(el["message"]);
            obj["entNotificationTime"] = el["notificationTime"];
            this.allEntNotifications.push(obj);
         })
      }
   }



   getExternalSharingActivity(url) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc => {
               self.showListData = true;
               resolve(suc);
            },
            error => {
               if(error.status ! =403){
                  console.log("error in getting activity logs details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
            }
         )
      });
   }

   public setExternalSharingActivityData(result, pageno) {
      var self = this;
      this.isMoreOptionsRequired = true;
      this.tableCaption = 'External Sharing';
      if (result != null && result.objects != undefined && result.objects.length > 0) {
         this.previousOffset = result.previousOffset;
         this.nextOffset = result.nextOffset;
         result.objects.map(function (currentValue) {
            currentValue.name = ((currentValue.actorFirstName != undefined) ? currentValue.actorFirstName : '') + " " + ((currentValue.actorLastName != undefined) ? currentValue.actorLastName : '');
            currentValue.fileExtn = "" ;
            if(currentValue.shareType!=undefined && currentValue.shareType == 'R' && currentValue.objectName!=undefined && currentValue.objectType!=undefined && currentValue.objectType == "FE"){
                  currentValue.fileExtn = "." + [currentValue.objectName.substr(0,currentValue.objectName.lastIndexOf('.')),currentValue.objectName.substr(currentValue.objectName.lastIndexOf('.')+1,currentValue.objectName.length)][1];
                  currentValue.objectName = [currentValue.objectName.substr(0,currentValue.objectName.lastIndexOf('.')),currentValue.objectName.substr(currentValue.objectName.lastIndexOf('.')+1,currentValue.objectName.length)][0]
            }else if(currentValue.shareType!=undefined && currentValue.shareType == 'L'){
               currentValue.objectName =  currentValue.shareName;
            }
         });

         this.tableRecords = result.objects;
         this.moreOptions = [];
         this.itemsPerPage = this.externalSharingItemsPerPage;

         this.pageNumber = pageno;
         if(this.pageNumber == 1){
            this.getTotalPages(result.totalRecords,this.itemsPerPage);
         }
         this.moreOptions = this.universalService.entMoreOption['reportOptions'];
      } else {
         this.tableRecords = [];
         this.totalPages = 0;
      }
   }

   getTotalPages(totalRecords,itemsPerPage){
      let remainder = totalRecords % itemsPerPage;
      let quotient =  (totalRecords - remainder) / itemsPerPage;
      this.totalItems  = totalRecords;
      if(remainder>0)
         this.totalPages = quotient+1;
      else
         this.totalPages = quotient;
   }

   public async createNewGroup(url,payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.post(url,payload).subscribe(
            resp => {
               //self.setGroupsListData(resp,"add");
               //self.groupCount += 1;
               self.universalService.showLoader = false;
               resolve(resp);
            },
            async error=>{
               self.universalService.showLoader = false;
               await self.getErrorMess(error.error.code)
               reject(error);
              
           },
         )
      })
   }

   public async addMembersGroup(url,payload, isAddedToExistingGroup) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.post(url,payload).subscribe(
            resp => {
               let temp = 0;
               resp.forEach(function(obj) {
                  if(obj["remarks"] == 'SUCCESS'){
                     temp++;
                  }
                })
               resp["membersAdded"] = temp;
               resp["groupKey"] = payload["groupKey"];
               self.setGroupsListData(resp,"addMember",self.pageNumber);
               self.universalService.showLoader = false;
               resolve(resp);
            },
            async err => {
               await self.getErrorMess(err.error.code)
               reject(err);
            }
         )
      })
   }

   public async deleteMembersGroup(url,payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,payload).subscribe(
            resp => {
               let temp = 0;
               resp.forEach(function(obj) {
                  if(obj["remarks"] == 'SUCCESS'){
                     temp++;
                  }
                })
               resp["membersAdded"] = temp;
               resp["groupKey"] = payload["groupKey"];
               self.setGroupsListData(resp,"deleteMember",self.pageNumber);
               self.universalService.showLoader = false;
               let msg = "Group " + self.groupName + " modified successfully";
               self.universalService.showToast(msg,"success");
               resolve(resp);
            },
            async err => {
               await self.getErrorMess(err.error.code)
               reject(err);
            }
         )
      })
   }

   public async getMembersGroup(url,param) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url,{params: param}).subscribe(
            resp => {
               self.universalService.showLoader = false;
               self.validGroupName = true;
               self.displayList = resp.members.map(function(ele){
                  let obj = self.usersMap[ele["userId"]];
                  return {
                     "recipientId" : ele["emailId"],
                     "role" : ele["roleCode"],
                     "isNewRecipient" : false,
                     "userId" : ele["userId"],
                     "firstName" : obj["firstName"],
                     "lastName" : obj["lastName"],
                     "isNew" : false,
                     "profileIconPhotoPath" : ele["profileIconPhotoPath"],
                     "accountId" : ele["accountId"]
                   }
               })
               self.serverMembersList = [...self.displayList];
               resolve(resp);
            },
            async err => {
               await self.getErrorMess(err.error.code)
               reject(err);
            }
         )
      })
   }
   
   public async renameGroup(url,payload) {
      var self = this;
      return new Promise(function (resolve, reject) {
         let param = {"groupKey":self.groupKey};
         self.http.put(url,payload,{params: param}).subscribe(
            resp => {
               self.universalService.showLoader = false;
               self.setGroupsListData(resp,"rename",self.pageNumber );
               let msg = "Group " + self.groupName + " modified successfully";
               self.universalService.showToast(msg,"success");
               resolve(resp);
            },
            async error => {
               self.universalService.showLoader = false;
               if(error.error.code  == "ENTC20213"){
                  self.setGroupsListData(param,"remove",self.pageNumber );
               }
               await self.getErrorMess(error.error.code)
               reject(error);
            }
         )
      })
   }


   public async deleteGroup(url,param,grpName) {
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.put(url,{},{params: param}).subscribe(
            resp => {
               //self.groupCount -= 1;
               self.universalService.showLoader = false;
               //self.setGroupsListData(param,"remove",self.pageNumber );
               let msg = "Group " + grpName + " deleted successfully";
               self.universalService.showToast(msg,"success");
               resolve(resp);
            },
            async err => {
               if(err.error.code  == "ENTC20213"){
                  self.setGroupsListData(param,"remove",self.pageNumber );
               }
               await self.getErrorMess(err.error.code)
               reject(err);
            }
         )
      })
   }

   getSearchedAll(url,tab) {
      var self = this;
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            suc=>{
               resolve(suc.users);
            },
            error=>{
               if(error.status ! =403){
                  console.log("error in getting searched All details.", error);
                  self.universalService.showErrorMessage(error);
                  self.universalService.isServerError = false;
                  reject(error);
               }
           },
         )
      });
   }

   getErrorMess(errCode){
      let msg = "";
      if(errCode == "ENTC20211"){
         msg = TOAST["GROUP_CREATE_MODIFY_DISALLOWED"];
      }else if(errCode == "ENTC20213"){
         msg = TOAST["GROUP_CREATE_MODIFY_FAILURE"];
      }else if(errCode == "ENTC20215"){
         msg = TOAST["GROUP_NAME_EXISTS"];
      }else if(errCode == "ENTC20216"){
         msg = TOAST["GROUP_MEMBER_DELETE_FAILURE"];
      }else {
         msg = TOAST["GENERIC_ERROR"];
      }
      this.universalService.showToast(msg,"error");

   }

   resetCreateSaveButtonValidation(){
      //reset to default value
      this.displayList = [];
      this.groupName = "";
      this.groupDesc  = "";
      this.existingGroupName = "";
      this.existingGroupDesc  = "";
      this.serverMembersList = [];
      this.validGroupName = false;
      this.updateMemberList = false;
      this.groupNameChanged = false;
      this.groupDescChanged = false;
    }

    getCaptcha(url){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            resp => {
               self.universalService.showLoader= false;
               resolve(resp);
            },
            err => {
               reject(err);
            }
         )
      })
  }

  submitBannerAction(url,params){
      var self = this;
      return new Promise(function(resolve, reject){
          self.http.post(url, params).subscribe(
              async (suc) => {
                  self.universalService.showLoader= false;
                  resolve(suc);	
              },
              (error:HttpErrorResponse) => {
                  // self.universalService.showToast(LOGIN_ERROR.BannerApiError, "error")
                  reject(error);
              },
          );
      })
  }
    getSize(object){
         var B = parseInt(object["sizeInBytes"]);
         var KB = (B / 1024);
         var MB = KB / 1024;
         var GB = MB / 1024;
         if (MB >= 1024) {
            object["objectSize"] = (GB).toFixed(2) + " GB"
         } else if (KB >= 1024) {
            object["objectSize"] = (MB).toFixed(2) + " MB"
         } else if (B >= 1024) {
            object["objectSize"] = (KB).toFixed(2) + " KB"
         } else {
            if(B==0){
               object["objectSize"] = (B).toFixed(2) + " KB"
            }else{
               object["objectSize"] = (B).toFixed(2) + " B"
            }
            
         }
         if(object.sizeInBytes == 0){
            return "0 B";
         }
         return object["objectSize"];
      }


      getAllTeams(url){
        var self = this;
         return new Promise(function (resolve, reject) {
            self.http.get(url).subscribe(
               suc=>{
                  self.universalService.showLoader = false;
                  self.universalService.allTeamsFoldersArray = self.universalService.allTeamsFoldersArray.concat(suc["teams"]);
                  resolve(suc); 
               },
               error=>{
                  if(error.status ! =403){
                     console.log("error in getEntNotifications.", error);
                     self.universalService.showErrorMessage(error);
                     self.universalService.isServerError = false;
                     self.universalService.showLoader = false;
                     reject(error);
                  }
              },
            )
         });
      }
      
      updateCountsAndTitle(count){
         var self = this;
         if(self.router.url.includes('/manageusers/pendinginvite')){
            self.universalService.entHeaderTitle = ENT_PAGE_TITLE.INVITES_PENDING + " ("+count+")";
          }else if(self.router.url.includes('/manageusers/usersinactive')){
            self.universalService.entHeaderTitle = ENT_PAGE_TITLE.INACTIVE_USERS + " ("+count+")";
          }else if(self.router.url.includes('/manageusers')){
            self.universalService.entHeaderTitle = ENT_PAGE_TITLE.MANAGE_USERS
            self.totalUsers = count;
          }
      }

}
